// This is intentionally sparse.
// The bundler will handle tree-shaking and dead-code elimination.
// During testing, this file will be mocked.
// See: jest.preset.js
//
// Why?
// `import.meta.env` is a Vite-specific feature that provides environment variables
// to client-side code. It's a syntax construct that is replaced at build time.
// Jest, running in a Node.js environment, does not understand this syntax and
// will fail with a parsing error.
//
// To solve this, we isolate the `import.meta.env` access into this single file.
// In our application code, we import the `env` object from here.
// In our Jest configuration, we use `moduleNameMapper` to replace this file
// with a mock that provides `process.env` instead, which Jest understands.
// This keeps our application code clean and standard, while allowing tests to run.

interface ImportMetaEnv {
  [key: string]: string
}

interface ImportMeta {
  env: ImportMetaEnv
}

export const env = (import.meta as unknown as ImportMeta).env
